var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-1" }, [
    _c("div", { staticClass: "stats-section shadow" }, [
      _c("div", { staticClass: "balance-due-bar" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-end justify-content-between" },
        [
          _c("div", { staticClass: "p-1" }, [
            _c("h6", { staticClass: "stats-section-title mt-2" }, [
              _vm._v("Balance due")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "primary-sum" }, [
              _vm._v("\n          " + _vm._s(_vm.sums.balance) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column p-1" }, [
            _c("span", { staticClass: "balance-due-average-label" }, [
              _vm._v("Avg")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "balance-due-average-amount" }, [
              _vm._v(_vm._s(_vm.averages.balance))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between border-top"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-50 d-flex align-items-end justify-content-between ml-3"
            },
            [
              _c("div", { staticClass: "p-1" }, [
                _c("h6", { staticClass: "stats-section-title mt-2" }, [
                  _vm._v("Company profit")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "secondary-sum" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.sums.carrier_total) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column p-1" }, [
                _c("span", { staticClass: "balance-due-average-label" }, [
                  _vm._v("Avg")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "balance-due-average-amount" }, [
                  _vm._v(_vm._s(_vm.averages.carrier_total))
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between border-top"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-50 d-flex align-items-end justify-content-between mr-3"
            },
            [
              _c("div", { staticClass: "p-1" }, [
                _c("h6", { staticClass: "stats-section-title mt-2" }, [
                  _vm._v("Cluster profit")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "secondary-sum" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.sums.cluster_total) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column p-1" }, [
                _c("span", { staticClass: "balance-due-average-label" }, [
                  _vm._v("Avg")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "balance-due-average-amount" }, [
                  _vm._v(_vm._s(_vm.averages.cluster_total))
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "stats-section shadow mt-3" }, [
        _c("div", { staticClass: "grand-total-bar" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-end justify-content-between" },
          [
            _c("div", { staticClass: "p-1" }, [
              _c("h6", { staticClass: "stats-section-title mt-2" }, [
                _vm._v("Grand total")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "primary-sum" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.sums.total_price) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column p-1" }, [
              _c("span", { staticClass: "grand-total-average-label" }, [
                _vm._v("Avg")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "grand-total-average-amount" }, [
                _vm._v(_vm._s(_vm.averages.total_price))
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center justify-content-between border-top"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "w-50 d-flex align-items-end justify-content-between mr-3"
              },
              [
                _c("div", { staticClass: "p-1" }, [
                  _c("h6", { staticClass: "stats-section-title mt-2" }, [
                    _vm._v("Cash")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "secondary-sum" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sums.cash_payment) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column p-1" }, [
                  _c("span", { staticClass: "grand-total-average-label" }, [
                    _vm._v("Avg")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "grand-total-average-amount" }, [
                    _vm._v(_vm._s(_vm.averages.cash_payment))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "w-50 d-flex align-items-end justify-content-between ml-3"
              },
              [
                _c("div", { staticClass: "p-1" }, [
                  _c("h6", { staticClass: "stats-section-title mt-2" }, [
                    _vm._v("Credit")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "secondary-sum" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sums.total_credit) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column p-1" }, [
                  _c("span", { staticClass: "grand-total-average-label" }, [
                    _vm._v("Avg")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "grand-total-average-amount" }, [
                    _vm._v(_vm._s(_vm.averages.total_credit))
                  ])
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mt-3"
        },
        [
          _c("div", { staticClass: "stats-section w-50 mr-2 shadow" }, [
            _c("div", { staticClass: "deposit-total-bar" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-end justify-content-between" },
              [
                _c("div", { staticClass: "p-1" }, [
                  _c("h6", { staticClass: "stats-section-title mt-2" }, [
                    _vm._v("Deposit")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "secondary-sum" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sums.deposit) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column p-1" }, [
                  _c("span", { staticClass: "deposit-total-average-label" }, [
                    _vm._v("Avg")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "deposit-total-average-amount" }, [
                    _vm._v(_vm._s(_vm.averages.balance))
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-section w-50 ml-2 shadow" }, [
            _c("div", { staticClass: "tips-total-bar" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-end justify-content-between" },
              [
                _c("div", { staticClass: "p-1" }, [
                  _c("h6", { staticClass: "stats-section-title mt-2" }, [
                    _vm._v("Tips")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "secondary-sum" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sums.card_tips) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column p-1" }, [
                  _c("span", { staticClass: "tips-total-average-label" }, [
                    _vm._v("Avg")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "tips-total-average-amount" }, [
                    _vm._v(_vm._s(_vm.averages.card_tips))
                  ])
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mt-3"
        },
        [
          _c("div", { staticClass: "stats-section w-50 mr-2 shadow" }, [
            _c("div", { staticClass: "time-total-bar" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-end justify-content-between" },
              [
                _c("div", { staticClass: "p-1" }, [
                  _c("h6", { staticClass: "stats-section-title mt-2" }, [
                    _vm._v("Time")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "secondary-sum" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sums.time) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column p-1" }, [
                  _c("span", { staticClass: "time-total-average-label" }, [
                    _vm._v("Avg")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "time-total-average-amount" }, [
                    _vm._v(_vm._s(_vm.averages.time))
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-50 ml-2" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f2f61f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2f61f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/TotalsStatisticsMobile.vue
// module id = null
// module chunks = 